import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Alert,
} from '@mui/material';
import { updateStaff } from '../../../services/staffService';

const STAFF_TYPES = [
  { value: 'admin', label: 'Administrator' },
  { value: 'nurse', label: 'Nurse' },
  { value: 'carer', label: 'Carer' },
];

const EditStaffDialog = ({ open, onClose, onSuccess, initialData }) => {
  const [form, setForm] = useState({
    staff_name: '',
    type_of_career: 'carer',
    qualification: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (initialData) {
      setForm({
        staff_name: initialData.staff_name || '',
        type_of_career: initialData.type_of_career || 'carer',
        qualification: initialData.qualification || '',
      });
    }
  }, [initialData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!initialData) return;
    setLoading(true);
    setError('');
    try {
      await updateStaff(initialData.staff_id || initialData.id, form);
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to update staff member');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Edit Staff</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Display Name" name="staff_name" value={form.staff_name} onChange={handleChange} fullWidth margin="normal" required />
        <TextField select label="Role" name="type_of_career" value={form.type_of_career} onChange={handleChange} fullWidth margin="normal">
          {STAFF_TYPES.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField label="Qualification" name="qualification" value={form.qualification} onChange={handleChange} fullWidth margin="normal" required />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditStaffDialog;
